class NotificationService {
    private container: HTMLElement | null = null;

    constructor() {
        this.createContainer();
    }

    private createContainer() {
        if (typeof document !== "undefined") {
            this.container = document.createElement("div");
            this.container.id = "notification-container";
            this.container.className = "fixed top-4 right-4 z-50 space-y-2";
            document.body.appendChild(this.container);
        }
    }

    private showNotification(
        message: string,
        type: "success" | "error" | "info" | "warning",
    ) {
        if (!this.container) return;

        const notification = document.createElement("div");
        const icons = {
            success: "✅",
            error: "❌",
            info: "ℹ️",
            warning: "⚠️",
        };

        const colors = {
            success: "bg-green-500",
            error: "bg-red-500",
            info: "bg-blue-500",
            warning: "bg-yellow-500",
        };

        notification.className = `${colors[type]} text-white px-6 py-4 rounded-lg shadow-lg flex items-center space-x-3 transform transition-all duration-300 translate-x-full`;
        notification.innerHTML = `
            <span class="text-xl">${icons[type]}</span>
            <span class="font-medium">${message}</span>
        `;

        this.container.appendChild(notification);

        // Animate in
        setTimeout(() => {
            notification.classList.remove("translate-x-full");
            notification.classList.add("translate-x-0");
        }, 100);

        // Remove after 3 seconds
        setTimeout(() => {
            notification.classList.add("translate-x-full");
            setTimeout(() => {
                if (notification.parentNode) {
                    notification.parentNode.removeChild(notification);
                }
            }, 300);
        }, 3000);
    }

    success(message: string) {
        this.showNotification(message, "success");
    }

    error(message: string) {
        this.showNotification(message, "error");
    }

    info(message: string) {
        this.showNotification(message, "info");
    }

    warning(message: string) {
        this.showNotification(message, "warning");
    }
}

const notificationService = new NotificationService();

export default notificationService;
